
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/hooks/useAuth";
import { Shield, User, Crown, Building2 } from "lucide-react";
import Loader from "@/components/ui/loader";
import { useI18n } from "@/hooks/useI18n";

const UserRoleDisplay = () => {
  const { userRole, loading } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="flex items-center gap-2">
        <Loader size="lg" />
        <span className="text-gray-500">{t('common.loading')}</span>
      </div>
    );
  }

  if (!userRole) {
    return null;
  }

  const getRoleConfig = (role: string) => {
    console.log("Determining role config for role:", role);
    switch (role) {
      case 'travel_designer':
        return {
          label: t('role.travelAdvisor'),
          icon: <Shield className="w-3 h-3" />,
          variant: 'default' as const,
          className: 'bg-orange-100 text-orange-800 hover:bg-orange-200'
        };
      case 'admin':
        return {
          label: t('role.admin'),
          icon: <Crown className="w-3 h-3" />,
          variant: 'destructive' as const,
          className: 'bg-purple-100 text-purple-800 hover:bg-purple-200'
        };
      case 'agency':
        return {
          label: t('role.agency'),
          icon: <Building2 className="w-3 h-3" />,
          variant: 'default' as const,
          className: 'bg-blue-100 text-blue-800 hover:bg-blue-200'
        };
      case 'traveler':
        return {
          label: t('role.traveler'),
          icon: <User className="w-3 h-3" />,
          variant: 'secondary' as const,
          className: 'bg-gray-700 text-gray-100 hover:bg-gray-600'
        };
      case 'travel_advisor_member':
        return {
          label: t('role.travelAdvisorMember'),
          icon: <Crown className="w-3 h-3" />,
          variant: 'secondary' as const,
          className: 'bg-blue-100 text-blue-800 hover:bg-blue-200'
        };
      default:
        return {
          label: t('role.unknown'),
          icon: <User className="w-3 h-3" />,
          variant: 'outline' as const,
          className: ''
        };
    }
  };

  const config = getRoleConfig(userRole);

  return (
    <Badge variant={config.variant} className={`flex items-center gap-1 text-sm px-2 py-0.5 w-fit ${config.className}`}>
      {config.icon}
      {config.label}
    </Badge>
  );
};

export default UserRoleDisplay;
